import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../auth-n-routing/auth-service.service';

@Component({
	selector: 'app-gaia-handler',
	templateUrl: './gaia-handler.component.html',
	styleUrls: ['./gaia-handler.component.css']
})
export class GaiaHandlerComponent implements OnInit {

	constructor(private router: Router,
				private activatedRoute: ActivatedRoute,
				private authService: AuthService) {
		const _http = this.activatedRoute.queryParams.subscribe(params => {
			const code = params['code'];
			if (code) {
				this.authService.login(code).then(res => {
					if (res) {
						this.router.navigate(['/dashboard/add']);
					} else {
						this.router.navigate(['/']);
					}
				}).catch(err => {
					this.router.navigate(['/']);
				});
			} else {
				this.router.navigate(['/']);
			}
		}, (error: any) => {
			console.log(error);
			_http.unsubscribe();
		});
	}

	ngOnInit() {
	}
}
